// src/utils/googleAuth.js
import React from 'react';

// Web client IDs are public; the env var overrides the default for other deployments.
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
  || '849928045683-d6kkdpp3h58lkc5ns52trebeal703tht.apps.googleusercontent.com';

const randomState = () => {
  try {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  } catch (e) {
    return Math.random().toString(36).slice(2) + Date.now().toString(36);
  }
};

// Redirects to Google's sign-in page (token flow). Works for both sign up and log in:
// the backend creates the account on first sign-in. Returns an error message, or null on success.
export const startGoogleSignIn = () => {
  if (!GOOGLE_CLIENT_ID) return "Google sign-in is not configured.";
  const state = randomState();
  // Saved in both storages so the check still works if Google returns in a new tab or in-app browser
  try { sessionStorage.setItem("googleOAuthState", state); } catch (e) { /* blocked */ }
  try { localStorage.setItem("googleOAuthState", state); } catch (e) { /* blocked */ }
  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: window.location.origin + "/auth/google/callback",
    response_type: "token",
    scope: "openid email profile",
    include_granted_scopes: "true",
    prompt: "select_account",
    state,
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  return null;
};

export const GoogleIcon = () => (
  <svg style={{ width: '18px', height: '18px', marginRight: '10px' }} viewBox="0 0 24 24" aria-hidden="true"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
);
